module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/27eb5fe70cedf28176edc100ba2225e3.png";